import { apiGet, apiPatch } from './client';
import type {
  DisclosureLevel1,
  DisclosureLevel1BatchRequest,
} from '../types/DisclosureLevel1';

export function getDisclosureLevel1(): Promise<DisclosureLevel1[]> {
  return apiGet<DisclosureLevel1[]>('/api/disclosure-level-1');
}

export function saveBatchDisclosureLevel1(
  added: DisclosureLevel1[],
  modified: DisclosureLevel1[],
  deletedIds: string[],
): Promise<DisclosureLevel1[]> {
  return apiPatch<DisclosureLevel1BatchRequest, DisclosureLevel1[]>(
    '/api/disclosure-level-1/batch',
    { added, modified, deleted: deletedIds },
  );
}
